import { Component } from '@angular/core';
import { ProjectsService } from '../../services/project.service';
import { PopupService } from '../../services/popup.service';
import { SaveIdeaService } from 'src/app/services/save-idea.service';
import { AppService } from 'src/app/api.service';

@Component({
  selector: 'app-save-idea-popup',
  templateUrl: './save-idea-popup.component.html',
  styleUrls: ['./save-idea-popup.component.scss','../../product-v3/product-v3.component.scss']
})
export class SaveIdeaPopupComponent {
constructor(public _project:ProjectsService,public _pop:PopupService,public _sis:SaveIdeaService, public _as:AppService){

}

}
